import { lazy } from 'react';

export const MainPage = lazy(() => import('./main'));
export const ProductPage = lazy(() => import('./product'));
export const WixEditorPage = lazy(() => import('./wix-editor'));
